import React, { useState, useRef, useEffect } from "react";
//import axios from 'axios';
import { Link, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import classes from "./HomePage.module.css";
import SecBTN from "../../UI/SecBTN";
import Modals from "../../UI/Modals/Modals";
import logo from "../../assets/img/motion-logo.png";
import googlePlay from "../../assets/img/google-play.png";
import arrow from "../../assets/img/rounded_arrow.png";
import sec3Img from "../../assets/img/sec3-img.png";
import arrowRight from "../../assets/img/arrow-right.png";
import nvsir from "../../assets/img/nvsir.png";
import sec4Img from "../../assets/img/sec4-img.png";
import HpHeading from "./HomePageComponets/HpHeading";
import Sec2Comp from "./HomePageComponets/Sec2Comp";
import { useForm } from "react-hook-form";
//
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../app/slices/auth";
import SmallLoader from "../../UI/SmallLoader/SmallLoader";
import { Alert } from "react-bootstrap";
import StartUpLoader from "../../UI/StartUpLoader/StartUpLoader";
import AuthService from "../../app/services/auth.service";
//import { clearMessage } from "../../app/slices/message";

const HomePage = (props) => {
  const [isLoading, setIsLoading] = useState(true);

  function loadingRequest() { //Simulates a request; makes a "promise" that'll run for 2.5 seconds
    return new Promise(resolve => setTimeout(() => resolve(), 2000));
  } 

  useEffect(() => {
    loadingRequest().then(() => {
        setIsLoading(!isLoading);
    });
  },[]);
  //Modal State management
  const [show, setShow] = useState(false);
  const [showPswd, setShowPswd] = useState(false);
  const [show1, setShow1] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();
  const handleClose = () => {
    setShow(false);
    setShow1(false);
    setShowOtpStep(false);
    setOtp("");
    setOtpError("");
    setErrShow(false);
    setErrMsg(defaultErrMsg);
    setLoginCredentials({ username: "", password: "" });
  };
  const handleShow = () => setShow(true);
  const handleShow1 = () => setShow1(true);
  const form = useRef();
  // const [username, setUsername] = useState("");
  // const [password, setPassword] = useState("");

  // const onChangeUsername = (e) => {
  //   const username = e.target.value;
  //   setUsername(username);
  // };

  // const onChangePassword = (e) => {
  //   const password = e.target.value;
  //   setPassword(password);
  // };
  ///
  const [loading, setLoading] = useState(false);
  const [resData, setResData] = useState([]);
  const [errShow, setErrShow] = useState(false);
  // Default login error (used if API doesn't send a message)
  const defaultErrMsg = "Username or password  not matched, try again !!!";
  const [errMsg, setErrMsg] = useState(defaultErrMsg);
  const [showOtpStep, setShowOtpStep] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpMobile, setOtpMobile] = useState(""); // mobile number from login response
  const [resendLoading, setResendLoading] = useState(false);
  const [loginCredentials, setLoginCredentials] = useState({ username: "", password: "" });
  const { isLoggedIn } = useSelector((state) => state.auth);
  //const { message } = useSelector((state) => state.message);
  const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(clearMessage());
  // }, [dispatch]);
  const navigate = useNavigate();
  
  const handleLogin = (e) => {
    console.log(e)
    setLoading(true);
    setErrShow(false);
    setErrMsg(defaultErrMsg);
    
    // Store credentials for OTP verification
    setLoginCredentials({ username: e.username, password: e.password });
    
    dispatch(login(e))
      .unwrap()
      .then((res) => {
        console.log("response", res)
        setLoading(false);
        // If login is successful, show OTP step
        if (res.user && res.user?.success === 1) {
          setShowOtpStep(true);
          setOtp("");
          setOtpError("");
          // Save mobile number for OTP info text (try common keys safely)
          setOtpMobile(
            res.user?.maskedMobile
          );
        } else {
          // Login failed – show API message under password
          setErrShow(true);
          setErrMsg(res.user?.message || defaultErrMsg);
        }
      })
      .catch((error) => {
        setLoading(false);
        // Network / unexpected error – still show a clear message
        setErrMsg(defaultErrMsg);
        setErrShow(true);
      });
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (!otp || otp.length < 4) {
      setOtpError("Please enter a valid OTP");
      return;
    }
    
    setLoading(true);
    setOtpError("");
    
    try {
      const res = await AuthService.verifyOtp(
        loginCredentials.username,
        loginCredentials.password,
        otp
      );
      
      if (res.success === 1 || res.accessToken) {
        navigate("/d");
        window.location.reload();
      } else {
        setOtpError("Incorrect OTP. Kindly enter correct OTP.");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      setOtpError("Incorrect OTP. Please try again.");
    }
  };

  const handleResendOtp = async () => {
    setResendLoading(true);
    setOtpError("");
    
    try {
      await AuthService.resendOtp(
        loginCredentials.username,
        loginCredentials.password
      );
      setOtp("");
      // You can show a success message here if needed
    } catch (error) {
      setOtpError("Failed to resend OTP. Please try again.");
    } finally {
      setResendLoading(false);
    }
  };

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Only allow numbers
    if (value.length <= 6) { // Limit to 6 digits
      setOtp(value);
      setOtpError("");
    }
  };
  useEffect(()=>{
    const user = JSON.parse(localStorage.getItem('user'))
    if(user){
      console.log(user.data.user)
      setResData(user.data.user)
    }
  },[])
  const contactUsSubmitHandler = (e) => {
    e.preventDefault();
  };

  return (
    <React.Fragment>
    {isLoading && <StartUpLoader/>}
      <Navbar expand="lg" className="py-lg-4 py-md-3 py-sm-2 py-3">
        <Container>
          <Navbar.Brand href="#home">
            <img className={classes.logo} src={logo} alt="Motion" />
          </Navbar.Brand>
          <Nav className="ms-auto">
            {isLoggedIn ? (
              <>
                <SecBTN className={classes.welcome}>
                  Hello <span style={{fontWeight:"bold",textTransform:"capitalize"}}>{resData.user_name}</span>
                </SecBTN>
                <SecBTN className={`${classes.dashboard}`}>
                  <Link to="/">
                    Dashbord <i className="bx bx-right-arrow-alt"></i>
                  </Link>
                </SecBTN>
              </>
            ) : (
              <>
                <SecBTN className={classes["contact-us"]}>
                  <a href="tel:7792814887">Contact Us</a>
                </SecBTN>
                <SecBTN className={classes["login-btn"]} onClick={handleShow}>
                  Log In
                </SecBTN>
              </>
            )}
          </Nav>
          
          <Modals show={show} onHide={handleClose}>
            <h4 className="text-center mb-2">{showOtpStep ? "Enter OTP" : "Log in"}</h4>
            
            <form onSubmit={showOtpStep ? handleVerifyOtp : handleSubmit(handleLogin)} ref={form}>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>User Id</Form.Label>
                {showOtpStep ? (
                  <Form.Control
                    type="text"
                    disabled={true}
                    readOnly={true}
                    value={loginCredentials.username}
                    style={{ backgroundColor: "#e9ecef", cursor: "not-allowed" }}
                  />
                ) : (
                  <Form.Control
                    name="username"
                    type="text"
                    disabled={loading}
                    placeholder="Enter User Id"
                    {...register('username', { required: true})}
                  />
                )}
              </Form.Group>
              <Form.Group
                className="mb-3"
                style={{ position: "relative" }}
                controlId="formBasicPassword"
              >
                <Form.Label>Password</Form.Label>
                {showOtpStep ? (
                  <Form.Control
                    type="password"
                    disabled={true}
                    readOnly={true}
                    value={loginCredentials.password}
                    style={{ backgroundColor: "#e9ecef", cursor: "not-allowed" }}
                  />
                ) : (
                  <>
                    <Form.Control
                      name="password"
                      disabled={loading}
                      type={showPswd ? "text" : "password"}
                      placeholder="Enter Password"
                      {...register('password', { required: true})}
                    />
                    {showPswd ? (
                      <i className={`fa-regular fa-eye-slash ${classes.showpswd}`} onClick={()=> setShowPswd(prev => !prev)} ></i>
                    ) : (
                      <i className={`fa-regular fa-eye ${classes.showpswd}`} onClick={()=> setShowPswd(prev => !prev)}></i>
                    )}
                  </>
                )}
              </Form.Group>
              
              {showOtpStep && (
                <>
                  <Form.Group className="mb-2" controlId="formOtp">
                    <Form.Label>Enter OTP</Form.Label>
                    <Form.Control
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      value={otp}
                      onChange={handleOtpChange}
                      disabled={loading}
                      placeholder="Enter OTP"
                      maxLength={6}
                      autoFocus
                    />
                  </Form.Group>
                  {otpMobile && (
                    <p className="text-muted mb-2" style={{ fontSize: "0.85rem" }}>
                      OTP sent on <strong>{otpMobile}</strong> Mobile Number 
                    </p>
                  )}
                  {otpError && (
                    <Alert className="p-2 mb-3" variant="danger" show={true}>
                      <p className="mb-0">{otpError}</p>
                    </Alert>
                  )}
                  <div className="d-flex justify-content-end align-items-center mb-3">
                    <button
                      type="button"
                      onClick={handleResendOtp}
                      disabled={resendLoading || loading}
                      className="btn btn-link p-0"
                      style={{ textDecoration: "none", fontSize: "14px" }}
                    >
                      {resendLoading ? "Sending..." : "Resend OTP"}
                    </button>
                  </div>
                </>
              )}
              
              {!showOtpStep && (
                <Alert className="p-2 mb-0" variant="danger" show={errShow} transition={true} onClose={() => {
                  setErrShow(false)
                  setErrMsg(defaultErrMsg)
                }} dismissible>
                  <p>{errMsg}</p>
                </Alert>
              )}
              
              <SecBTN 
                className={classes["login-modal-btn"]} 
                type="submit" 
                disabled={loading || (showOtpStep && !otp)}
              >
                {showOtpStep ? "Verify OTP" : "Log In"} {loading && <SmallLoader/>}
              </SecBTN>
            </form>
          </Modals>
        </Container>
      </Navbar>
      {/* Section 1 */}
      <Container fluid className={classes.section1}>
        <Container className={classes.container}>
          <Row>
            <Col lg={7} md={9} sm={12} className={classes["sec1-col1"]}>
              <div className={classes["sec1-col1-sub"]}>
                <h1 className={classes["sec1-heading1"]}>
                  Make your faculty’s <br /> work easy with our
                </h1>
                <h1 className={classes["sec1-heading2"]}>Motion Guru App</h1>
                <a href="https://play.google.com/store/apps/details?id=motion.tachersapp">
                  <img src={googlePlay} alt="Google Play" />
                </a>
              </div>
            </Col>
            <Col lg={5} md={3} sm={12} className={classes["sec1-col2"]}>
              {/* <img className="img-fluid" src={facultyImg} alt="facultyImg" /> */}
              <img
                className="img-fluid"
                src={nvsir}
                alt="NvSirImg"
              />
            </Col>
          </Row>
        </Container>
      </Container>
      {/* Section 2 */}
      <Container fluid className={classes.section2}>
        <Container>
          <HpHeading
            heading="Benefits you experience?"
            subHeading="Motion Faculty App with the help of technology offers you with vide range of features which will save your faculty’s time and efforts along with recording their activities."
          />
          <Row>
            <Sec2Comp />
          </Row>
          <div className={classes.arrow}>
            <img src={arrow} alt="" />
          </div>
        </Container>
      </Container>
      {/* Section 3 */}
      <Container fluid className={classes.section3}>
        <Container>
          <HpHeading
            heading="Personalized Reports and Insights"
            subHeading="Get reports and analyse  the performance of both Faculty and Student."
          />
          <Row className="mt-5">
            <Col lg={6} md={6} sm={12}>
              <img className="img-fluid" src={sec3Img} alt="" />
            </Col>
            <Col
              lg={6}
              md={6}
              sm={12}
              className={`my-4 ${classes["sec3-col2"]}`}
            >
              <Row>
                <Col className="text-end" xs={2}>
                  <img className="img-fluid" src={arrowRight} alt="" />
                </Col>
                <Col xs={10}>
                  <h4 className="my-2">Faculty Performance Analytics</h4>
                  <p className="mb-4">
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s, when an unknown printer took a galley
                    printer took a galley
                  </p>
                </Col>
                <Col className="text-end" xs={2}>
                  <img className="img-fluid" src={arrowRight} alt="" />
                </Col>
                <Col xs={10}>
                  <h4 className="my-2">Student Performance Analytics</h4>
                  <p>
                    Lorem Ipsum has been the industry's standard dummy text ever
                    since the 1500s, when an unknown printer took a galley
                    printer took a galley
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Container>
      {/* Section 4 */}
      <Container fluid className={classes.section4}>
        <Container>
          <Row>
            <Col lg={6} md={6} xs={12} className={classes["sec4-col1"]}>
              <div>
                <h3>Why Motion?</h3>
                <p>We are specialize in custom content creation</p>
                <ul className={classes["sec4-ol"]}>
                  <li>Best related content</li>
                  <li>Lorem Ipsum is simply dummy text of the printing </li>
                  <li>It is a long established fact</li>
                  <li>Contrary to popular belief, Lorem Ipsum</li>
                </ul>
                <SecBTN className={classes["sec4-btn"]}>
                  Collaborate with us <i className="bx bx-right-arrow-alt"></i>{" "}
                </SecBTN>
              </div>
            </Col>
            <Col lg={6} md={6} xs={12}>
              <img src={sec4Img} className="img-fluid" alt="" />
            </Col>
          </Row>
          <div className={classes["sec4-arrow"]}>
            <img src={arrow} alt="" />
          </div>
        </Container>
      </Container>
      {/* Section 4 */}
      <Container fluid className={classes.footer}>
        <Container>
          <h2 className="text-center">Get In Touch</h2>
          <Row>
            <Col lg={2} md={0} sm={0}></Col>
            <Col lg={4} md={6} sm={12} className={classes["footer-col1"]}>
              <p>
                Have a query about the product? Get in touch with us at the
                provided contact details and we will guide you.
              </p>
              <SecBTN className={classes["footer-btn"]} onClick={handleShow1}>
                Get In Touch
              </SecBTN>
            </Col>
            <Col lg={4} md={6} sm={12} className={classes["footer-col2"]}>
              <p>
                <i className="bx bxs-phone-call"></i> +91 9000000000
              </p>
              <p>
                <i className="bx bxs-envelope"></i> info@motion.com
              </p>
              <p>
                <i className="bx bxs-map"></i> 394, Rajeev Nagar, Kota - 324005
              </p>
            </Col>
            <Col lg={2} md={0} sm={0}></Col>
          </Row>
          <Modals show={show1} onHide={handleClose}>
            <h4 className="text-center mb-2">Contact Us </h4>
            {/*contact us Form */}
            <form onSubmit={contactUsSubmitHandler}>
              <Form.Group className="mb-2" controlId="name">
                <Form.Label>Your Name</Form.Label>
                <Form.Control type="Text" placeholder="Enter your Name" />
              </Form.Group>
              <Form.Group className="mb-2" controlId="institute-name">
                <Form.Label>Institute Name</Form.Label>
                <Form.Control
                  type="Text"
                  placeholder="Enter your Institute Name"
                />
              </Form.Group>
              <Form.Group className="mb-2" controlId="email">
                <Form.Label>Email Id</Form.Label>
                <Form.Control type="email" placeholder="Enter Email Id" />
              </Form.Group>
              <Form.Group className="mb-2" controlId="phone">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter your Phone Number"
                />
              </Form.Group>
              <Form.Group className="mb-2" controlId="message">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Write your message"
                  style={{ height: "100px" }}
                />
              </Form.Group>
              <SecBTN className={classes["login-modal-btn"]} type="submit">
                Submit
              </SecBTN>
            </form>
          </Modals>
        </Container>
      </Container>
    </React.Fragment>
  );
};

export default HomePage;
